import jQuery from 'jquery';

export default class MeliaServiceHelper {
	static getHotelDetails(meliaURLs, hotelID, lang) {
		const deferred = jQuery.Deferred();
		const hotelIDParamURL = 'hotelId';
		const langParamURL = 'lang';
		const url = meliaURLs.HotelSheet.replace(
			`{${hotelIDParamURL}}`,
			hotelID
		).replace(`{${langParamURL}}`, lang);
		this.getMethod(deferred, url);
		return deferred.promise();
	}

	static getHotelsByDestinationCode(meliaURLs, destinationCode, lang) {
		const deferred = jQuery.Deferred();
		const langParamURL = 'lang';
		const destCodeParamURL = 'dest_code';
		const url = meliaURLs.SearchDataDestination.replace(
			`{${destCodeParamURL}}`,
			destinationCode
		).replace(`{${langParamURL}}`, lang);
		this.getMethod(deferred, url);
		return deferred.promise();
	}

	static getDestinationsTree(meliaURLs, lang) {
		const deferred = jQuery.Deferred();
		const langParamURL = 'lang';
		const url = meliaURLs.DestinationsTree.replace(`{${langParamURL}}`, lang);
		this.getMethod(deferred, url);
		return deferred.promise();
	}

	static getHotelPrices(meliaURLs, hotelId, currency, countryId) {
		const deferred = jQuery.Deferred();
		const countryIdParamURL = 'countryId';
		const hotelIDParamURL = 'hotelId';
		const currencyParamURL = 'currency';
		const url = meliaURLs.HotelPrices
			.replace(`{${countryIdParamURL}}`,countryId)
			.replace(`{${hotelIDParamURL}}`, hotelId)
			.replace(`{${currencyParamURL}}`, currency);
		this.getMethod(deferred, url);
		return deferred.promise();
	}
	
	static getHotelURL(meliaURLs, hotelId, hotelTitle, lang) {
		const deferred = jQuery.Deferred();
		const hotelIDParamURL = 'hotelId';
		const hotelTitleParamURL = 'hotelTitle';
		const langParamURL = 'lang';
		const url = meliaURLs.friendlyUrl
			.replace(`{${hotelTitleParamURL}}`,hotelTitle)
			.replace(`{${hotelIDParamURL}}`, hotelId)
			.replace(`{${langParamURL}}`, lang);
		this.getMethod(deferred, url);
		return deferred.promise();
	}

	static getMethod(deferred, url) {
		jQuery.ajax({
			url: url,
			type: 'GET',
			success: responseData => {
				deferred.resolve(responseData);
			},
			error: responseData => {
				deferred.reject(responseData);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/helpers/MeliaServiceHelper.js